import { lazy, Suspense, type ReactElement } from 'react';

const ReactQueryDevtoolsLazy = lazy(async () => {
  const mod = await import('@tanstack/react-query-devtools');
  return {
    default: function DevtoolsPanel(): ReactElement {
      return <mod.ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />;
    },
  };
});

function shouldMountDevtools(): boolean {
  if (import.meta.env.DEV) {
    return true;
  }
  if (typeof window === 'undefined') {
    return false;
  }
  return window.rnmAjax?.reactQueryDevtools === true;
}

export function MaybeReactQueryDevtools(): ReactElement | null {
  if (!shouldMountDevtools()) {
    return null;
  }
  return (
    <Suspense fallback={null}>
      <ReactQueryDevtoolsLazy />
    </Suspense>
  );
}
